import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const defaultCheckMTGBalToGLFields = {
  matchAmtFlag: '',
  date: '',
  mtgAmt: '',
  mtgRunningTotal: '',
  mtgGLBalance: '',
  mtgCertFeeAmt: '',
  mtgCertFeeRunningTotal: '',
  mtgCertFeeGLBalance: '',
};

export const checkMTGBalanceToGL = {
  namespaced: true,
  actions: {
    async mtgBalToGLGatherInformation({ commit, dispatch }, { criteria }) {
      let results;
      const gqlfields = defaultCheckMTGBalToGLFields;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`query
                    mtgBalToGLGatherInformation ($criteria:mtgBalToGLGatherInfoCriteriaType) {
                    mtgBalToGLGatherInformation(criteria: $criteria){
                    ${fieldsToGqlString(gqlfields)}
                    },
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        const result = results.data ? (results.data.mtgBalToGLGatherInformation || {}) : {};
        // console.info(results.data, 'res');
        return result;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There is a problem while collecting gather information.', { root: true });
      }
      return null;
    },
  },
};
export default checkMTGBalanceToGL;
